export default {
    state: {
        loading: false,
    },
    getters: {
        /**
         * Retorna o estado do loading
         * @param state
         * @returns {boolean}
         */
        getLoading: state => {
            return state.loading;
        }
    },
    mutations: {
        /**
         * Seta o estado do loading
         * @param state
         * @param payload
         */
        setLoading: (state, payload) => {
            state.loading = payload;
        },

        /**
         * Alterna o estado do loading
         * @param state
         */
        toggleLoading: (state) => {
            state.loading = !state.loading;

        }

    }
}
